import { CommonModule } from '@angular/common';
import {
  SupplierPurchaseOrderListDto,
  SupplierPurchaseOrderService,
} from '@digiwall/goliath-documents/proxy';
import { BaseSupplierDocList } from '../../base-supplier-docs/base-supplier-doc-list';
import { ColDef } from '@ag-grid-community/core';
import {
  DwGridDataSourceService,
  FieldTypes,
  IEnumerationCellRendererParams,
} from '@digiwall/ag-grid';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService, SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { Component, Injector } from '@angular/core';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';

@Component({
  selector: 'document-supplier-purchase-order-list',
  templateUrl: './supplier-purchase-order-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class SupplierPurchaseOrderListComponent extends BaseSupplierDocList<
  SupplierPurchaseOrderListDto,
  SupplierPurchaseOrderService
> {
  private _columns: ColDef[] = [
    ...this.colDefs,
    {
      field: 'supplierDeliveryModeId',
      headerName: this.localizationService.instant('GoliathCore::DeliveryMode'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.coreEnumerationTypeStore.supplierDeliveryModes,
      } as IEnumerationCellRendererParams,
    },
    {
      field: 'estimatedAvailabilityDate',
      headerName: this.localizationService.instant(
        'Doc::SupplierPurchaseOrder:EstimatedAvailabilityDate',
      ),
      type: FieldTypes.Date,
    },
    {
      field: 'additionalCostPricePercentage',
      headerName: this.localizationService.instant(
        'Doc::SupplierPurchaseOrder:AdditionalCostPricePercentage',
      ),
      type: FieldTypes.Percentage,
      hide: true,
    },
    {
      field: 'estimatedAvailabilityWeek',
      headerName: this.localizationService.instant(
        'Doc::SupplierPurchaseOrder:EstimatedAvailabilityWeek',
      ),
      type: FieldTypes.Number,
      hide: true,
    },
    {
      field: 'isReceived',
      headerName: this.localizationService.instant('Doc::SupplierPurchaseOrder:IsReceived'),
      type: FieldTypes.Boolean,
      hide: true,
    },
    {
      field: 'supplierOrderStatusId',
      headerName: this.localizationService.instant('Doc::SupplierOrder:SupplierOrderStatus'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.documentEnumerationTypeStore.supplierOrderStatus,
      } as IEnumerationCellRendererParams,
    },
  ];

  get columns(): ColDef[] {
    return this._columns;
  }

  constructor(
    protected service: SupplierPurchaseOrderService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
  ) {
    super(
      service,
      router,
      route,
      confirmation,
      localizationService,
      subscriptionService,
      datasource,
      injector,
    );
  }

  duplicateSupplierQuote() {
    this.service.getAnnexesCount(this.selectedEntities()[0].id).subscribe(count => {
      this.duplicateDoc(count != 0);
    });
  }
}
